import React from 'react';

export const LogoFull = () => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '4px 0' }}>
      <img
        src="/marketcast-icon.png"
        alt="MarketHub"
        style={{ width: '28px', height: '28px', objectFit: 'contain' }}
      />
      <span
        style={{
          fontFamily: '"Century Gothic", "Volte", -apple-system, BlinkMacSystemFont, sans-serif',
          fontWeight: 700,
          fontSize: '20px',
          letterSpacing: '-0.5px',
          color: '#ffffff',
          lineHeight: 1,
        }}
      >
        Market<span style={{ color: '#3cb5e6' }}>Hub</span>
      </span>
    </div>
  );
};
